export default __webpack_public_path__ + "static/media/Another_with_optimised_colour.0ea3a213.png";